import request from '@/utils/request'

export function taskDownload(taskId) {
  return request({
    url: `/api/manage/async/task/download/${taskId}`,
    method: 'get',
    responseType: 'blob'
  })
}

export function taskPage(params) {
  return request({
    url: `/api/manage/async/task/page`,
    method: 'get',
    params,
  })
}

export function taskSubmit(data) {
  return request({
    url: `/api/manage/async/task/submit`,
    method: 'post',
    data,
  })
}

export function taskDel(taskId) {
  return request({
    url: `/api/manage/async/task/${taskId}`,
    method: 'delete'
  })
}

export default {
  taskDownload,
  taskPage,
  taskSubmit,
  taskDel
}